import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import BlogList from "../../components/BlogList";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";

const BlogPage = (props) => {
  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />

        <main className="page_content">
          <PageTitle pageTitle={"Our Blog"} pagesub={"Our Blogs"} />
          <div className=" bg-white">
            <BlogList />
          </div>
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </Fragment>
  );
};
export default BlogPage;
